// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports_wrapper__ezoK- {
  display: flex;
  align-items: center;
  justify-content: center;
}

.reports_content__HjUHN {
  max-width: 611px;
  width: 100%;
  display: grid;
  grid-template-rows: min-content 1fr;
  gap: 24px;
}

textarea {
  height: 200px;
  min-height: 200px;
  max-width: 611px;
  min-width: 200px;
  max-height: 400px;
  padding: 12px;
  border: 1px solid var(--primary-border-color);
  border-radius: 4px;
}

.reports_actions__YDVbJ {
  display: flex;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/routes/reports.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.content {\n  max-width: 611px;\n  width: 100%;\n  display: grid;\n  grid-template-rows: min-content 1fr;\n  gap: 24px;\n}\n\ntextarea {\n  height: 200px;\n  min-height: 200px;\n  max-width: 611px;\n  min-width: 200px;\n  max-height: 400px;\n  padding: 12px;\n  border: 1px solid var(--primary-border-color);\n  border-radius: 4px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `reports_wrapper__ezoK-`,
	"content": `reports_content__HjUHN`,
	"actions": `reports_actions__YDVbJ`
};
export default ___CSS_LOADER_EXPORT___;
